import React from "react";
import { Route } from "react-router-dom";
import PackageTrackPageFeature from "../../features/package-track-page-feature";
import PackageDetailFeature from "features/package-detail-feature/PackageDetailFeature";

export const PackageStackNavigation = () => {
  return (
    <>
      <Route
        exact
        path="/package"
        component={PackageTrackPageFeature}
      />
      <Route
        path="/package/detail"
        component={PackageDetailFeature}
      />
    </>
  );
};
